import {useCallback} from 'react';
import {useTrackingClient} from '../../../../tracking/context/TrackingClientContext';
import {contextIsAvailable} from '../../../../tracking/hooks/trackingHelpers';
import {useTracking} from '../../../../tracking/hooks/useTracking';

export function useTrackFormSubmit() {
  const trackingClient = useTrackingClient();
  const {pageContext} = useTracking();

  return useCallback(() => {
    if (contextIsAvailable(pageContext)) {
      trackingClient?.trackShopFeature({
        feature: {type: 'submit', label: 'contact_form_submit', value: null},
      });
    }
  }, [trackingClient, pageContext]);
}
